import { OnboardingRouteNames } from "@/routes/onboarding"

export const ONBOARDING_STEP_WITH_STICKY_REINSURANCES = [
    OnboardingRouteNames.MeterDetails,
    OnboardingRouteNames.MeterDetailsMonoEnergy,
    OnboardingRouteNames.ProviderCalendar,
    OnboardingRouteNames.EnergyLandscape,
    OnboardingRouteNames.PersonalDetails,
    OnboardingRouteNames.PaymentDetails,
    OnboardingRouteNames.OrderReview,
]

export const ONBOARDING_STEP_WITH_TRUSTPILOT = [
    OnboardingRouteNames.MeterDetails,
    OnboardingRouteNames.MeterDetailsMonoEnergy,
    OnboardingRouteNames.ProviderCalendar,
    OnboardingRouteNames.EnergyLandscape,
    OnboardingRouteNames.MeterReadings,
    OnboardingRouteNames.PersonalDetails,
    OnboardingRouteNames.PaymentDetailsFinancialSituation,
    OnboardingRouteNames.PaymentDetails,
    OnboardingRouteNames.OrderReview,
    OnboardingRouteNames.PrePayment,
    OnboardingRouteNames.PrePaymentCdf,
]
